(() => {
  'use strict';
  const cfg = window.DokumolaUrgency || {};
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const OFFSET = 3 * 3600e3; // Türkiye saati (UTC+3, yaz saati uygulanmıyor)
  const DAY = 86400e3;
  const DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  const shipDays = cfg.shipDays === 'mon-sat' ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5];
  const pad = n => String(n).padStart(2, '0');
  const trDate = d => new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d);
  const trMonth = d => new Intl.DateTimeFormat('tr-TR', { month: 'long', timeZone: 'UTC' }).format(d);

  // Türkiye takvim gününü UTC gece yarısı olarak temsil eder
  const istToday = now => { const t = new Date(now + OFFSET); return Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()); };

  function cutoffInfo(now) {
    const today = istToday(now);
    const dow = new Date(today).getUTCDay();
    const cutoff = today + (Number(cfg.cutoffHour) || 15) * 3600e3 - OFFSET;
    if (shipDays.includes(dow) && now < cutoff) return { today: true, remaining: cutoff - now, ship: today };
    let ship = today;
    do { ship += DAY; } while (!shipDays.includes(new Date(ship).getUTCDay()));
    return { today: false, ship, isTomorrow: ship - today === DAY };
  }
  const addDeliveryDays = (from, n) => { let d = from; let left = n; while (left > 0) { d += DAY; if (new Date(d).getUTCDay() !== 0) left--; } return d; };

  function campaignRemaining(now) {
    if (cfg.campaignMode === 'off') return null;
    if (cfg.campaignMode === 'daily') return istToday(now) + DAY - OFFSET - now; // bugün 23:59:59'a kadar
    const raw = String(cfg.campaignEnd || '').trim();
    const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    const end = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59) - OFFSET;
    return end - now;
  }

  // "{süre}" gibi yer tutucuları kalın yazıyla doldurur; metin güvenli şekilde eklenir
  function fill(target, template, values) {
    const parts = String(template).split(/(\{[^}]+\})/);
    target.replaceChildren(...parts.filter(Boolean).map(part => {
      const key = part.slice(1, -1);
      if (part.startsWith('{') && key in values) { const s = document.createElement('strong'); s.textContent = values[key]; return s; }
      return document.createTextNode(part);
    }));
  }

  function tick() {
    const now = Date.now();
    if (cfg.cutoffEnabled) {
      const info = cutoffInfo(now);
      const h = Math.floor(info.remaining / 3600e3), m = Math.floor(info.remaining % 3600e3 / 60e3), s = Math.floor(info.remaining % 60e3 / 1e3);
      const day = info.isTomorrow ? 'yarın' : DAYS[new Date(info.ship).getUTCDay()];
      $$('[data-dk-cutoff]').forEach(el => {
        const out = el.querySelector('[data-dk-cutoff-text]'); if (!out) return;
        const compact = el.closest('.dk-urgency-bar');
        const duration = compact ? `${pad(h)}:${pad(m)}:${pad(s)}` : (h > 0 ? `${h} sa ${m} dk` : `${m} dk ${s} sn`);
        if (info.today) fill(out, el.dataset.before || '{süre}', { 'süre': duration });
        else fill(out, el.dataset.after || '{gün}', { 'gün': day });
      });
      const minDay = addDeliveryDays(info.ship, Number(cfg.deliveryMin) || 3);
      const maxDay = addDeliveryDays(info.ship, Math.max(Number(cfg.deliveryMin) || 3, Number(cfg.deliveryMax) || 5));
      const a = new Date(minDay), b = new Date(maxDay);
      const range = a.getUTCMonth() === b.getUTCMonth() ? `${a.getUTCDate()}–${b.getUTCDate()} ${trMonth(b)}` : `${trDate(a)} – ${trDate(b)}`;
      $$('[data-dk-eta]').forEach(el => { const out = el.querySelector('[data-dk-eta-text]'); if (out) fill(out, el.dataset.template || '{tarih}', { 'tarih': range }); });
    } else {
      $$('[data-dk-eta]').forEach(el => { el.hidden = true; });
    }

    const left = campaignRemaining(now);
    const active = left !== null && left > 0;
    $$('[data-dk-campaign]').forEach(el => { el.hidden = !active; });
    $$('[data-dk-countdown]').forEach(el => { el.hidden = !active; });
    if (active) {
      const d = Math.floor(left / DAY), h = Math.floor(left % DAY / 3600e3), m = Math.floor(left % 3600e3 / 60e3), s = Math.floor(left % 60e3 / 1e3);
      $$('[data-dk-timer]').forEach(el => { el.textContent = (d > 0 ? `${d}g ` : '') + `${pad(h)}:${pad(m)}:${pad(s)}`; });
      $$('[data-dk-countdown]').forEach(el => {
        const set = (u, v) => { const t = el.querySelector(`[data-dk-unit="${u}"]`); if (t) t.textContent = pad(v); };
        set('days', d); set('hours', h); set('minutes', m); set('seconds', s);
        const dayBox = el.querySelector('[data-dk-unit-box="days"]'); if (dayBox) dayBox.hidden = d === 0;
      });
    }
    $$('[data-dk-urgency-bar]').forEach(bar => { bar.hidden = !bar.querySelector('.dk-urgency-bar__item:not([hidden])'); });
  }

  /* ---------- Çıkış penceresi ---------- */
  function initPopup() {
    const dialog = document.getElementById('UrgencyPopup');
    if (!cfg.popup || !dialog) return;
    const KEY = 'dokumola-popup-shown';
    const seen = () => { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
    const open = () => {
      if (seen() || dialog.open || document.querySelector('dialog[open]')) return;
      const count = Number((document.querySelector('.cart-count') || {}).textContent) || 0;
      if (count >= 2) return;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      dialog.showModal();
    };
    const startedAt = Date.now();
    document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - startedAt > 5000) open(); });
    if (matchMedia('(hover: none)').matches) setTimeout(open, 40000);
  }

  /* ---------- Mobilde dönen şerit mesajları ---------- */
  let barIndex = 0;
  function rotateBar() {
    $$('.dk-urgency-bar--rotate').forEach(bar => {
      const items = $$('.dk-urgency-bar__item', bar).filter(i => !i.hidden);
      if (!items.length) return;
      barIndex = (barIndex + 1) % items.length;
      items.forEach((item, i) => item.classList.toggle('is-current', i === barIndex % items.length));
    });
  }
  function markFirstBarItem() {
    $$('.dk-urgency-bar--rotate').forEach(bar => {
      const items = $$('.dk-urgency-bar__item', bar).filter(i => !i.hidden);
      if (items.length && !items.some(i => i.classList.contains('is-current'))) items[0].classList.add('is-current');
    });
  }

  /* ---------- Alt bilgideki büyük marka yazısı ---------- */
  function initGiant() {
    const el = document.querySelector('[data-dk-giant]');
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    const text = el.textContent.trim();
    const highlight = (el.dataset.highlight || '').trim().toLocaleLowerCase('tr');
    const from = highlight ? text.toLocaleLowerCase('tr').lastIndexOf(highlight) : -1;
    el.textContent = '';
    [...text].forEach((ch, i) => {
      const span = document.createElement('span');
      span.className = 'dk-giant__ch' + (from > -1 && i >= from && i < from + highlight.length ? ' dk-giant__ch--hl' : '');
      span.style.setProperty('--i', i);
      span.textContent = ch;
      el.appendChild(span);
    });
    if (!el.classList.contains('dk-footer__giant--animate')) return;
    const end = document.querySelector('[data-dk-giant-end]');
    let endVisible = false;
    const nearBottom = () => {
      const doc = document.scrollingElement || document.documentElement;
      const viewport = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      return (window.pageYOffset || doc.scrollTop) + Math.max(viewport, window.innerHeight) >= doc.scrollHeight - 80;
    };
    const inView = () => { const r = el.getBoundingClientRect(); return r.top < window.innerHeight * 0.95 && r.bottom > 0; };
    const update = () => {
      if (inView()) el.classList.add('is-in'); else if (el.getBoundingClientRect().top > window.innerHeight) el.classList.remove('is-in');
      el.classList.toggle('is-colored', el.classList.contains('is-in') && (endVisible || nearBottom()));
    };
    // Harfler yalnızca JavaScript çalışınca gizlenir; bir sorun olursa yazı görünür kalır.
    el.classList.add('is-armed');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.target === end) endVisible = entry.isIntersecting;
        update();
      }), { rootMargin: '0px 0px 60px 0px', threshold: [0, 0.1] }).observe(end || el);
      if (end) new IntersectionObserver(() => update(), { threshold: [0, 0.15, 0.5] }).observe(el);
    }
    ['scroll', 'resize', 'touchmove', 'touchend', 'orientationchange'].forEach(type => window.addEventListener(type, update, { passive: true }));
    if (window.visualViewport) window.visualViewport.addEventListener('resize', update);
    requestAnimationFrame(update);
  }

  const safe = fn => { try { fn(); } catch (err) { if (window.console) console.warn('dokumola:', err); } };
  function start() {
    safe(initGiant);
    safe(tick); safe(markFirstBarItem); safe(initPopup);
    setInterval(() => { safe(tick); safe(markFirstBarItem); }, 1000);
    setInterval(() => safe(rotateBar), 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', () => { safe(tick); safe(markFirstBarItem); safe(initGiant); });
})();
